import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';
import {Property} from "../../property.model";

export class SalesAddon extends AbstractReport {

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }

}

AccessorsMutatorsDecorator(
    'id',
    'name',
    'name_ar',
    'quantity',
    'amount',
    'average_price',
    'addon_amount',
)(SalesAddon);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/admin-report/sales-addon.model.js